import { useStore } from '@nanostores/react'
import { Dialog } from 'radix-ui'
import grantPermissionDialogHeaderImage from '~/assets/images/grant-permission-dialog-header.png'
import { m } from '~/paraglide/messages'
import {
  $grantPermissionDialog,
  grantPermissionDialog,
} from '~/store/grant-permission-dialog'

export function GrantPermissionDialog() {
  const state = useStore($grantPermissionDialog)

  return (
    <Dialog.Root
      open={state.isOpen}
      onOpenChange={(nextIsOpen) =>
        !nextIsOpen && grantPermissionDialog.onDismiss()
      }
    >
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-[60] bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <Dialog.Content
          className="fixed left-1/2 top-1/2 z-[60] w-[300px] -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-lg bg-white data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
          onPointerDownOutside={(event) => event.preventDefault()}
          onInteractOutside={(event) => event.preventDefault()}
          onOpenAutoFocus={(event) => event.preventDefault()}
          onEscapeKeyDown={(event) => event.preventDefault()}
          style={{
            ['--tw-enter-translate-x' as string]: '-50%',
            ['--tw-enter-translate-y' as string]: '-50%',
            ['--tw-exit-translate-x' as string]: '-50%',
            ['--tw-exit-translate-y' as string]: '-50%',
          }}
        >
          <img
            src={grantPermissionDialogHeaderImage}
            alt=""
            className="h-[140px] w-full object-cover"
          />

          <div className="flex flex-col items-center gap-4 px-5 pb-5 pt-4">
            <div className="flex flex-col items-center gap-3">
              <Dialog.Title className="text-center text-lg font-semibold text-[#333]">
                {m.dialog_trial_end_notification_title()}
              </Dialog.Title>

              <Dialog.Description className="text-center text-sm text-[#666]">
                {m.dialog_trial_end_notification_content({
                  date: state.reminderDate,
                })}
              </Dialog.Description>
            </div>

            <div className="flex w-full flex-col items-center gap-3">
              <button
                className="h-10 w-[250px] rounded bg-[#8EC925] text-base text-white"
                style={{
                  boxShadow: '0px 4px 0px 0px #4A8003',
                }}
                onClick={grantPermissionDialog.onConfirm}
              >
                {m.btn_remind_me()}
              </button>

              <button
                className="h-9 text-base font-bold text-[#888]"
                onClick={grantPermissionDialog.onDismiss}
              >
                {m.btn_no_need_reminder()}
              </button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
